import React, { useState } from 'react';
import styled from 'styled-components';

import { STAKING_ENABLED, VAULTS_ENABLED } from 'config/constants';
import { useSelector } from 'reduxState/store';

import { DividerMarginVerticalItem } from './items/DividerItems';
import HelpMenuDropdownItem from './items/HelpMenuDropdownItem';
import RewardsMenuItem from './items/RewardsMenuItem';
import MenuItemRenderer from './MenuItemRenderer';

import type { MenuItemType } from './headerTypes';

const Wrapper = styled.nav`
  display: flex;
  position: relative;
  height: calc(var(--header-height));
  font-size: var(--medium);
  color: var(--white);
  /** Correct menu alignement */
  padding-top: 1px;
`;

const BASE_MENU_ITEMS: MenuItemType[] = [
  {
    type: 'TopMenuLink' as const,
    label: 'Wallet',
    to: '/wallet',
  },
  {
    type: 'TopMenuLink' as const,
    label: 'Trade',
    to: '/',
    isTradingIndex: true,
  },
  ...(VAULTS_ENABLED
    ? [
        {
          type: 'TopMenuLink' as const,
          label: 'Vaults',
          to: '/vaults',
        },
      ]
    : []),
  ...(STAKING_ENABLED
    ? [
        {
          type: 'TopMenuLink' as const,
          label: 'Earn',
          to: '/staking',
        },
      ]
    : []),
  {
    type: 'TopMenuLink' as const,
    label: 'Markets',
    to: '/markets',
  },
  RewardsMenuItem,
  HelpMenuDropdownItem,
];

const WALLET_MENU_ITEMS: MenuItemType[] = [
  DividerMarginVerticalItem,
  ...BASE_MENU_ITEMS,
];

export function HeaderMenu() {
  const walletAddress = useSelector(state => state.wallet.walletAddress);
  const [isDropdownOpen, setDropdownOpen] = useState(false);

  const menuItems = walletAddress ? WALLET_MENU_ITEMS : BASE_MENU_ITEMS;

  return (
    <Wrapper>
      {menuItems.map((menuItem, idx) => {
        return (
          <MenuItemRenderer
            key={idx}
            menuItem={menuItem}
            linkProps={{ setDropdownOpen, isDropdownOpen }}
          />
        );
      })}
    </Wrapper>
  );
}
